import { useMainContext } from '@/context/main-context';
import { cn } from '@/lib/utils';
import { Footer } from './footer';
import { Navbar } from './navbar';

export default function DashboardLayout({ children }) {
  const { isOpen } = useMainContext();

  return (
    <>
      {/* <Sidebar /> */}
      <nav
        className={cn(
          'sticky top-0 z-20 transition-[margin-left] ease-in-out duration-300'
        )}
      >
        <Navbar />
      </nav>
      <main
        className={cn(
          'min-h-[calc(100vh-50px)] transition-[margin-left] ease-in-out duration-300'
        )}
      >
        {children}
      </main>

      <Footer />
    </>
  );
}
